import styled from 'styled-components';

export const URLContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
    width: 100%;
`;